import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import { TextField, Autocomplete, Button, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';

const EditVariables = ({ subCondition, condition }) => {
  const dispatch = useDispatch();
  const [variables, setVariables] = useState(subCondition.variables || []);
  const [newVariable, setNewVariable] = useState({
    varType: 'QUERY_ONE',
    name: '',
    targetColumn: '',
    keyColumn: '',
    valueColumn: '',
    manualValue: '',
  });

  const handleAddVariable = () => {
    const variable = {
      name: newVariable.name,
      varType: newVariable.varType,
      targetColumnId: newVariable.targetColumn._id,
      keyColumnId: newVariable.keyColumn._id,
      valueColumnId: newVariable.valueColumn._id,
      manualValue: newVariable.manualValue,
      noneColumnName: newVariable.noneColumnName,
    };
    const updatedSubConditions = condition.subConditions.map((subCon) =>
      subCon._id === subCondition._id
        ? { ...subCon, variables: Array.isArray(subCon.variables) ? [...subCon.variables, variable] : [variable] }
        : subCon
    );
    dispatch(
      apiAction({
        reduxField: 'condition',
        route: 'conditions/updateSubConditions',
        conditionId: condition._id,
        subConditions: updatedSubConditions,
      })
    );
    setVariables([...variables, newVariable]);
    setNewVariable({
      varType: 'QUERY_ONE',
      name: '',
      targetColumn: '',
      keyColumn: '',
      valueColumn: '',
      manualValue: '',
    });
  };
  const handleDeleteVariable = (variableId) => {
    if (window.confirm('Are you sure you want to delete this variable?')) {
      const updatedVariables = variables.filter((variable) => variable._id !== variableId);
      const updatedSubConditions = condition.subConditions.map((subCon) =>
        subCon._id === subCondition._id ? { ...subCon, variables: updatedVariables } : subCon
      );
      dispatch(
        apiAction({
          reduxField: 'condition',
          route: 'conditions/updateSubConditions',
          conditionId: condition._id,
          subConditions: updatedSubConditions,
        })
      );
      setVariables(updatedVariables);
    }
  };

  const getColumnOptions = () => {
    return condition.columns;
  };
  console.log(newVariable);
  return (
    <div data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom'>
          <h1>Manage Variables ({subCondition.variables?.length || '0'})</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        {subCondition.variables?.map((variable) => (
          <div key={variable._id} className='col-lg-12 d-flex justify-content-center mt-2'>
            <div className='d-flex align-items-center'>
              <b>
                <span className='text-primary'>{variable.name} - </span> {variable.varType}:{' '}
              </b>
              {variable.varType === 'MANUAL' ? <span className='ml-2 p-2 border'>{variable.manualValue}</span> : null}
              {variable.varType === 'QUERY_ONE' || variable.varType === 'QUERY_MANY'
                ? (() => {
                    const targetColumn = condition.columns.filter((col) => col._id === variable.targetColumnId)[0];
                    const keyColumn = condition.columns.filter((col) => col._id === variable.keyColumnId)[0];
                    const valueColumn = condition.columns.filter((col) => col._id === variable.valueColumnId)[0];

                    if (!targetColumn?._id || !keyColumn?._id || !valueColumn?._id) {
                      return <span className='text-danger ml-2'>Columns Match - please regenerate variable</span>;
                    }
                    return (
                      <>
                        <span className='ml-2 p-2 border'>
                          <span className='text-info'>SELECT</span> {targetColumn.column_name}{' '}
                          <span className='text-info'>FROM</span> {targetColumn.table_name}{' '}
                          <span className='text-info'>WHERE</span> {keyColumn.column_name}=
                          {variable.manualValue ? (
                            <span className='text-info'>{variable.manualValue}</span>
                          ) : (
                            <span className='text-primary'>
                              VALUE FROM {valueColumn.table_name}:{valueColumn.column_name}
                            </span>
                          )}
                        </span>
                      </>
                    );
                  })()
                : null}
              {variable.varType === 'NONE_COLUMN_VALUE' ? (
                <>
                  <span className='ml-2 p-2 border'>{variable.noneColumnName}</span>
                </>
              ) : null}
              <button className='btn btn-outline-secondary border-0' onClick={() => handleDeleteVariable(variable._id)}>
                <i className='fa fa-trash' aria-hidden='true'></i>
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className='row d-flex justify-content-center mt-4 mb-4 pt-lg-0 border-top'>
        <div className='col-lg-12 d-flex justify-content-center mt-4'>
          <h6>Add a New Variable</h6>
        </div>
        <div className='col-lg-12 d-flex justify-content-center mb-2 mt-2'>
          {(() => {
            if (
              newVariable.varType === 'NONE_COLUMN_VALUE' &&
              newVariable.name &&
              newVariable.noneColumnName &&
              typeof newVariable.noneColumnName === 'string'
            ) {
              return (
                <button className='btn btn-outline-primary' onClick={handleAddVariable}>
                  Add None Column Value
                </button>
              );
            }
            if (
              newVariable.varType === 'MANUAL' &&
              newVariable.name &&
              newVariable.manualValue &&
              typeof newVariable.manualValue === 'string'
            ) {
              return (
                <button className='btn btn-outline-primary' onClick={handleAddVariable}>
                  Add Manual Variable
                </button>
              );
            }
            if (
              newVariable.varType !== 'MANUAL' &&
              newVariable.name &&
              newVariable.targetColumn?._id &&
              newVariable.keyColumn?._id
            ) {
              if (!newVariable.valueColumn?._id && !newVariable.manualValue) {
                return null;
              }
              return (
                <button className='btn btn-outline-primary' onClick={handleAddVariable}>
                  Add Variable
                </button>
              );
            }
          })()}
        </div>
        <div className='col-lg-3 d-flex justify-content-center mb-4'>
          <input
            type='text'
            className='form-control'
            onChange={(e) => setNewVariable({ ...newVariable, name: e.target.value })}
            placeholder='Variable Name...'
            value={newVariable.name}
            style={{ textAlign: 'center' }}
          />
        </div>
        <div className='col-lg-12 d-flex justify-content-center'>
          <Autocomplete
            options={['QUERY_ONE', 'QUERY_MANY', 'MANUAL', 'NONE_COLUMN_VALUE']}
            getOptionLabel={(option) => option}
            value={newVariable.varType}
            onChange={(event, newValue) => setNewVariable({ ...newVariable, varType: newValue })}
            renderInput={(params) => <TextField {...params} label='Variable Type' variant='outlined' />}
            style={{ width: 400 }}
          />
        </div>
        {newVariable.varType === 'MANUAL' ? (
          <div className='col-lg-12 d-flex justify-content-center mt-2'>
            <TextField
              label='Manual Value'
              variant='outlined'
              value={newVariable.manualValue}
              onChange={(e) => setNewVariable({ ...newVariable, manualValue: e.target.value })}
              style={{ width: 400 }}
            />
          </div>
        ) : null}
        {newVariable.varType === 'QUERY_ONE' || newVariable.varType === 'QUERY_MANY' ? (
          <>
            <div className='col-lg-12 d-flex justify-content-center mt-2'>
              <Autocomplete
                options={getColumnOptions()}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : `${option.table_name}.${option.column_name}`
                }
                value={newVariable.targetColumn}
                onChange={(event, newValue) => setNewVariable({ ...newVariable, targetColumn: newValue })}
                renderInput={(params) => <TextField {...params} label='Target Column' variant='outlined' />}
                style={{ width: 400 }}
              />
            </div>
            <div className='col-lg-12 d-flex justify-content-center mt-2'>
              <Autocomplete
                options={getColumnOptions()}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : `${option.table_name}.${option.column_name}`
                }
                value={newVariable.keyColumn}
                onChange={(event, newValue) => setNewVariable({ ...newVariable, keyColumn: newValue })}
                renderInput={(params) => <TextField {...params} label='Key Column' variant='outlined' />}
                style={{ width: 400 }}
              />
            </div>
            <div className='col-lg-12 d-flex justify-content-center mt-2'>
              <Autocomplete
                options={condition.columns
                  .map((col) => {
                    if (condition.rangeQuery?.columnsIds.includes(col._id)) {
                      return col;
                    }
                    return null;
                  })
                  .filter((flt) => flt)}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : `${option.table_name}.${option.column_name}`
                }
                value={newVariable.valueColumn}
                onChange={(event, newValue) => setNewVariable({ ...newVariable, valueColumn: newValue })}
                renderInput={(params) => <TextField {...params} label='Value Column' variant='outlined' />}
                style={{ width: 400 }}
              />
            </div>
            <div className='col-lg-12 d-flex justify-content-center mt-2'>
              <TextField
                label='Manual Value'
                variant='outlined'
                value={newVariable.manualValue}
                onChange={(e) => setNewVariable({ ...newVariable, manualValue: e.target.value })}
                style={{ width: 400 }}
              />
            </div>
          </>
        ) : null}
        {newVariable.varType === 'NONE_COLUMN_VALUE' ? (
          <div className='col-lg-12 d-flex justify-content-center mt-2'>
            <TextField
              label='None Column Value name'
              variant='outlined'
              value={newVariable.noneColumnName}
              onChange={(e) => setNewVariable({ ...newVariable, noneColumnName: e.target.value })}
              style={{ width: 400 }}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default EditVariables;
